import AppVisit from "@/components/internal/ads";
const appVisit = () => {
    return (
        <AppVisit />
    )
}

export default appVisit